import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--border)',
      padding: '24px 24px 36px',
      marginTop: 48,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '8px 20px',
      fontSize: 12,
      color: 'var(--text-muted)',
    }}>
      <span>Powered by <b style={{ color: 'var(--text-dim)' }}>TrainForge</b></span>
      <Link to="/pricing" style={{ color: 'var(--text-muted)' }}>Pricing</Link>
      <Link to="/learn" style={{ color: 'var(--text-muted)' }}>Learn</Link>
      <Link to="/about" style={{ color: 'var(--text-muted)' }}>About</Link>
      <Link to="/contact" style={{ color: 'var(--text-muted)' }}>Contact</Link>
      <Link to="/changelog" style={{ color: 'var(--text-muted)' }}>Changelog</Link>
      <Link to="/terms" style={{ color: 'var(--text-muted)' }}>Terms</Link>
      <Link to="/privacy" style={{ color: 'var(--text-muted)' }}>Privacy</Link>
    </footer>
  );
}
